import { useEffect } from 'react';

/**
 * Hook para cerrar modales con la tecla ESC
 * @param callback - Función a ejecutar cuando se presiona ESC
 * @param isEnabled - Si está habilitado (por defecto true)
 */
export const useEscapeKey = (callback: () => void, isEnabled: boolean = true) => {
  useEffect(() => {
    if (!isEnabled) return;

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape' || event.keyCode === 27) {
        event.preventDefault();
        callback();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [callback, isEnabled]);
};
